import React from 'react';
import './PlaceholderPage.css';

const EbayIntegrationPage = () => {
  return (
    <div className="placeholder-page">
      <h1 className="page-title">eBay Integration</h1>
      <p className="page-description">
        eBay marketplace integration settings will be added here.
      </p>
    </div>
  );
};

export default EbayIntegrationPage;
